/**
 * Ustawienia generatora reklam: kolory marki, palety, kroje per rodzaj tekstu
 * i limity AI. Jeden dokument na instalację, bo to decyzje marketingu, a nie
 * preferencje osoby układającej planszę.
 */
export const TEXT_ROLES = ['headline', 'subtitle', 'body', 'badge'] as const;
export type TextRole = typeof TEXT_ROLES[number];

/** Zapisany styl tekstu; stopień pisma jako ułamek krótszego boku planszy. */
export interface AdTextStyle {
  id: string;
  name: string;
  fontFamily: string;
  sizeRatio: number;
  fontWeight: number;
  color: string;
  uppercase: boolean;
  letterSpacing: number;
  lineHeight: number;
}

export interface AdPalette {
  id: string;
  name: string;
  colors: string[];
}

export interface AdGeneratorSettings {
  /** Logo marki w Bytescale. Puste = elementy używają sygnetu Hotelspota z panelu. */
  logoUrl: string;
  brandColors: string[];
  palettes: AdPalette[];
  textStyles: AdTextStyle[];
  fonts: Record<TextRole, string>;
  ai: { maxAssets: number };
  updatedAt: number | null;
}

export type AdGeneratorSettingsPatch = Partial<{
  logoUrl: string;
  brandColors: string[];
  palettes: AdPalette[];
  textStyles: AdTextStyle[];
  fonts: Partial<Record<TextRole, string>>;
  ai: { maxAssets: number };
}>;

export interface SettingsApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

/** Etykiety rodzajów tekstu w panelu ustawień. */
export const TEXT_ROLE_LABELS: Record<TextRole, string> = {
  headline: 'Nagłówek',
  subtitle: 'Podtytuł',
  body: 'Akapit',
  badge: 'Plakietka CTA',
};

/**
 * Wartości używane, zanim odpowiedź z backendu dojedzie. Ten sam komplet co
 * domyślne po stronie funkcji, żeby edytor nigdy nie stał bez palety ani kroju.
 */
export const FALLBACK_SETTINGS: AdGeneratorSettings = {
  logoUrl: '',
  brandColors: [
    '#0f3333', '#1a4d4d', '#18a785', '#c18344', '#f7f7f7', '#ffffff',
    '#f4f4f5', '#a1a1aa', '#3f3f46', '#18181b', '#000000', '#1a4d6d',
  ],
  palettes: [
    { id: 'brand', name: 'Hotelspot', colors: ['#0f3333', '#1a4d4d', '#18a785', '#c18344', '#ffffff'] },
  ],
  textStyles: [],
  fonts: {
    headline: 'Montserrat',
    subtitle: 'Montserrat',
    body: 'Montserrat',
    badge: 'Montserrat',
  },
  ai: { maxAssets: 3 },
  updatedAt: null,
};
